import { getTemple } from "../../js/storage";
import { downLoadBlobFile, getKeyTitle, isEmpty } from "../../js/tool";

export const flagOptions = [
  { key: 1, title: "是" },
  { key: 2, title: "否" },
];

export const getFlagText = function (value) {
  return getKeyTitle(flagOptions, value);
};

export default {
  name: "投诉",
  url: "/admin/record-complaint", // rest接口表名
  query: "&sort=-id", // rest接口query参数
  searchKeyType: {
    date: function (form, key) {
      let value = form[key];
      let res = "";
      if (value?.length > 0) {
        res = `&filter[create_time][gte]=${value[0]} 00:00:00&filter[create_time][lte]=${value[1]} 23:59:59`;
      }
      return res;
    },
    reason: 1,
  },
  // 列表渲染列
  columns: (ctx) => {
    // eslint-disable-next-line no-unused-vars
    const h = ctx.$createElement;
    return [
      {
        title: "提交时间",
        dataIndex: "create_time",
        customRender: (text) => text?.slice(0, -3),
      },
      {
        title: "提交人",
        dataIndex: "wx_user_id",
        customRender: (text) => <open-data type="userName" openid={text} />,
      },
      { title: "投诉事由", dataIndex: "reason" },
    ];
  },
  // 列表查询表单
  queryForm: [
    {
      key: "wx_user_id",
      label: "提交人",
      component: "select-book",
      props: {
        type: "user",
      },
    },
    {
      key: "date",
      label: "提交日期",
      component: "a-range-picker",
      props: {
        placeholder: ["开始日期", "结束日期"],
        format: "YYYY-MM-DD",
        valueFormat: "YYYY-MM-DD",
        allowClear: true,
        class: "range-picker",
      },
      style: {
        width: "240px",
      },
    },
    {
      key: "reason",
      label: "投诉事由",
      component: "a-input",
      props: {
        placeholder: "输入投诉事由查询",
        allowClear: true,
      },
      style: {
        width: "200px",
      },
    },
  ],
  buttons: [
    {
      name: "数据导出",
      component: "a-button",
      type: "primary",
      props: {
        type: "primary",
      },
      style: {
        "margin-left": "8px",
      },
      value: null,
      listeners: {
        click() {
          if (this.exporting) return;
          this.$set(this, "exporting", false);
          const temple = getTemple();
          let url = `/admin/record-complaint/export?temple_id=${temple}`;
          const form = this.$refs.dataList.form;
          if (form.wx_user_id) {
            url += `&wx_user_id=${form.wx_user_id}`;
          }
          if (form.date?.length === 2) {
            url += `&start_time=${form.date[0]}&end_time=${form.date[1]}`;
          }
          if (!isEmpty(form.reason)) {
            url += `&reason=${form.reason}`;
          }
          this.$axios(url, { noTempleFilter: true, responseType: "blob" })
            .then((res) => {
              downLoadBlobFile(res, "投诉数据");
            })
            .finally(() => {
              this.exporting = false;
            });
        },
      },
    },
  ],
  // 新增/编辑查询表单
  items: [],
  // 详情接口expand字段
  expand: "",
  init: {}, // 新增实体初始化字段
  dealDetail: function (detail) {
    return new Promise((resolve) => {
      detail.files = detail.file ? JSON.parse(detail.file) : [];
      resolve();
    });
  },
  // 详情渲染字段
  renderItems: (ctx) => {
    // eslint-disable-next-line no-unused-vars
    const h = ctx.$createElement;
    return [
      { label: "提交时间", key: "create_time", slot: (entity) => <span>{entity.create_time?.slice(0, -3)}</span> },
      {
        label: "提交人",
        key: "wx_user_id",
        slot: (entity) => <open-data type="userName" openid={entity.wx_user_id} />,
      },
      { label: "投诉事由", key: "reason" },
      { label: "事情经过", key: "happened" },
      {
        label: "是否满意",
        key: "is_satisfied",
        slot: (entity) => <span>{getFlagText(entity.is_satisfied)}</span>,
      },
      { label: "文件", key: "files", file: true },
    ];
  },
};
